import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import { Button, ConfirmDialog, IButtonProps } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

type WorksheetGridRefreshButtonProps = IButtonProps;

// Component that triggers a refresh of the worksheet grid
let WorksheetGridRefreshButton: React.FC<WorksheetGridRefreshButtonProps> = ({ disabled, ...otherProps }) => {
  const dispatch = useDispatch();

  const isSaving = useSelector((state) =>
    Object.values(state.worksheetGrid.worksheets).some((w) => w.status.synchronising)
  );
  const canRefresh = useSelector(
    (state) =>
      state.worksheetGrid.status.initialised &&
      state.worksheetGrid.status.queryReady &&
      !state.worksheetGrid.status.refreshing
  );
  const refreshing = useSelector((state) => state.worksheetGrid.status.refreshing);

  return (
    <ConfirmDialog
      confirm={isSaving}
      confirmText="Refreshing data while changes are being saved may result in changes being lost. Are you sure you want to continue?"
    >
      <Button
        primary
        loading={refreshing}
        onClick={() => {
          dispatch(actions.refresh());
        }}
        disabled={disabled || !canRefresh}
        {...otherProps}
      >
        Refresh
      </Button>
    </ConfirmDialog>
  );
};

WorksheetGridRefreshButton = withInjectedProps(WorksheetGridRefreshButton);

export default WorksheetGridRefreshButton;
export { WorksheetGridRefreshButton };
